import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { DefaultLink } from '@design-system/link';
export const Partner = ({ customLinkFont, description, imageUrl, name, url, }) => {
    const shouldDisplayImage = imageUrl
        ? !/^(?:\/images\/missing|\/logos\/default\/missing)/u.test(imageUrl)
        : false;
    const img = (_jsx(ImageWrapper, { "$shouldDisplayImage": shouldDisplayImage, children: shouldDisplayImage ? (_jsx(Box, { alt: "", "aria-hidden": "true", as: "img", src: imageUrl })) : (_jsx(FontAwesomeIcon, { color: "white", height: "40px", iconName: "buildings", iconType: CATEGORIES.LIGHT })) }));
    return (_jsxs(Box, { alignItems: "flex-start", my: 2, children: [url ? (_jsx(DefaultLink, { "aria-hidden": "true", href: url, tabIndex: -1, target: "_blank", children: img })) : (img), _jsxs(Box, { flexDirection: "column", justifyContent: "center", minHeight: "60px", children: [_jsx(Box, { fontWeight: "bold", mb: 1, children: url ? (_jsx(DefaultLink, { font: customLinkFont && customLinkFont, href: url, styledOnlyOnHover: true, target: "_blank", children: name })) : (name) }), description && _jsx(Box, { children: description })] })] }));
};
const ImageWrapper = styled(Box).attrs(() => ({
    alignItems: 'center',
    color: 'white',
    height: 60,
    justifyContent: 'center',
    maxWidth: 60,
    minWidth: 60,
    mr: 3,
})) `
  border-radius: 4px;
  background-color: ${({ $shouldDisplayImage, theme }) => $shouldDisplayImage ? 'transparent' : theme.colors.primary};

  img {
    border-radius: 4px;
  }
`;
//# sourceMappingURL=Partner.js.map